<template>
  <div>
    <div
      class="mt-3 mb-4 field-of-fields"
      style="width: 75%; display: block; margin-left: auto; margin-right: auto"
    >
      <a :href="$store.getters.website">
        <img
          :src="require(`../../../assets/img/logo/${$store.getters.logo}`)"
          width=""
          :height="$store.getters.logoHeight"
          :alt="$store.getters.agencyHumanName"
          style=""
          id=""
          class="center"
        />
      </a>
      <h1 class="center mt-5">Family Application Form</h1>

      <!-- ######### CONTACT INFORMATION ######### -->

      <hr />

      <div v-if="$store.getters.userID" class="center mt-5">
        <h3>You are registered!</h3>
        <div class="header-button mt-4">
          <!-- <router-link v-if="!auth" :to="{ name: 'Employer Registration'}"><button class="buttons button-1-dark">Add an Opportunity</button></router-link> -->
          <button @click="dashboardRedirect()" class="button button-1-dark">
            My Dashboard
          </button>
        </div>
      </div>

      <div v-if="!$store.getters.userID">
        <p class="text-require-notice">Fields marked with an * are required</p>
        <FormGroupRowLayout
          :listFields="$store.getters.familyInformationListFields"
          :modelData="familyFormData"
          :submitClicked="submitClicked"
        >
          <template slot="service-note">
            <div v-if="familyFormData.selector1 === SERVICE_TYPE.NEW_BORN">
              <p class="form-note">
                Please submit the family application to start your search for a
                Newborn Care Specialist (aka baby nurse/ night nurse).
                The agency fee for Newborn Care Specialists is 25% of the
                candidates gross contracted salary, per candidate. Most infant
                care specialist require a min of 2 week on assignment. A $250
                deposit and a family agreement is required to start. This
                deposit will allow us to guarantee that a NCS will be
                present at your home when you need them since birthdays can
                fluctuate. This deposit is non-refundable. The $250 deposit will
                be deducted from the placement fee which is due before the
                Newborn Care Specialist starts.
              </p>
              <a
                href="https://www.tinytreasuresnyc.com/find-newborn-baby-nurse"
              >
                Learn More Before Registering
              </a>
            </div>
            <div v-if="familyFormData.selector1 === SERVICE_TYPE.NANNY">
              <p class="form-note">
                Please submit the family application to start your search. There
                is a non-refundable fee of $250 due with submission, of which
                $200 will be applied to your final invoice. A placement
                specialist will contact you within 24 hours or the next business
                day. If you have any questions please don't hesitate to contact
                us. 646-290-5566 ext 1.
              </p>
              <p class="form-note">
                Have Questions before filling this out. Schedule a call with a
                Care Specialist (
                <a href="https://calendly.com/tinytreasuresnyc/15min">
                  Consultation
                </a>
                )
              </p>
            </div>
            <div
              v-if="familyFormData.selector1 === SERVICE_TYPE.PRIVATE_EDUCATOR"
            >
              <p class="form-note">
                We collect a non-refundable fee to start your search. This fee
                will be credited to your final placement invoice. We never store
                your card number or CVC number on our site.
              </p>
            </div>
          </template>
          <template slot="children">
            <ApplicationSectionWithDialog
              sectionTitle="Children"
              name="Children"
              :data="listChildren"
              :listFields="listChildrenFields"
              :keyTitles="['first_name', 'last_name']"
            />
          </template>
          <template slot="nanny-form-fee-notice">
            <p class="form-note">
              <b> Your credit card will be charged: $250.00</b>
            </p>
            <p class="form-note fee-note">
              We collect a non-refundable fee to start your search. This fee
              will be credited to your final placement invoice. We never store
              your card number or CVC number on our site.
            </p>
          </template>
        </FormGroupRowLayout>

        <div class="submit-button-section">
          <button
            class="mylisting-button dark-button"
            @click="submitApplication()"
          >
            Submit
          </button>
        </div>
      </div>
    </div>

    <modal
      name="update-aplication-modal"
      width="80%"
      height="auto"
      :scrollable="true"
      style="z-index: 9999;"
    >
      <!-- <h4 class="" style="font-weight: 500; margin-bottom: 0;">
        Please Enter Your Payment Information
      </h4>
      <p class="mt-2 mb-4">
        <span v-if="user.selector1 == 'Sitter'">Your information is securely stored and you will only be charged for services you book.</span>
        <span v-if="user.selector1 == 'Nanny' || user.selector1 == 'Newborn Care Specialist'">There is a non-refundable fee of $250 due with submission, of which $200 will be applied to your final invoice.</span>
        <span v-if="user.selector1 == 'Private Educator'">There is a non-refundable fee of $500 due with submission, of which $400 will be applied to your final invoice.</span>
      </p>
      <payments @subscribed="subscribed()" :email="user.email" :user="user"></payments>
      <div class="mt-2" style="margin-bottom: 40px;">
        <a href="https://www.stripe.com" target="_blank"
          ><img
            src="../../../assets/img/stripe/powered_by_stripe_outline@2x.png"
            alt="Powered by Stripe"
            width="150px"
            style="float: right;"
        /></a>
      </div> -->

      <!-- <hr> -->
      <!-- <button class="mylisting-button secondary-button" @click="$modal.hide('payment-modal')">Close</button> -->
    </modal>
  </div>
</template>

<script>
import axios from "axios";
import FormGroupRowLayout from "../../common/FormGroupRowLayout";
import DetailSectionRowLayout from "../../common/DetailSectionRowLayout";
import ApplicationSectionWithDialog from "../../common/ApplicationSectionWithDialog";
import router from "../../../router";
import { ACTION_TYPE } from "../../../constants/custom-define-type";
import { SERVICE_TYPE } from "../../../constants/employer";

import Payments from '../profile/Payments'

export default {
  components: {
    FormGroupRowLayout,
    DetailSectionRowLayout,
    ApplicationSectionWithDialog,
    Payments,
  },
  data() {
    return {
      submitClicked: false,
      familyFormData: {},
      numberChildrenSubmitSuccess: 0,
      SERVICE_TYPE: SERVICE_TYPE,
      listChildren: [],
    };
  },
  computed: {
    listChildrenFields() {
      return this.getListChildrenFields();
    },
    serviceType() {
      return this.familyFormData.selector1;
    },
  },
  watch: {
    serviceType(value) {
      // Find all field which corresponding with new service type
      const listFieldOfServiceType = this.getListFieldModelForOption(
        this.$store.getters.familyInformationListFields,
        value
      );
      // Keep the common data between old service type and new service type,
      // Remove other information
      this.familyFormData = this.extractSelectedFields(
        this.familyFormData,
        listFieldOfServiceType
      );
    },
  },
  methods: {
    getListChildrenFields() {
      if (this.familyFormData.selector1 === SERVICE_TYPE.NEW_BORN) {
        return this.$store.getters.childrenListFieldsNewBorn;
      } else if (this.familyFormData.selector1 === SERVICE_TYPE.SITTER) {
        return this.$store.getters.childrenListFieldsSitter;
      } else if (this.familyFormData.selector1 === SERVICE_TYPE.NANNY) {
        return this.$store.getters.childrenListFieldsNanny;
      } else if (this.familyFormData.selector1 === SERVICE_TYPE.PRIVATE_EDUCATOR) {
        return this.$store.getters.childrenListFieldsPrivateEducator;
      }
    },
    checkInvalidFields() {
      if (
        this.hasInvalidField(
          this.familyFormData,
          this.$store.getters.familyInformationListFields
        )
      ) {
        return true;
      }
      for (const child of this.listChildren) {
        if (this.hasInvalidField(child, this.getListChildrenFields())) {
          return true;
        }
      }
      return false;
    },
    submitApplication() {
      this.submitClicked = true;
      if (this.checkInvalidFields()) {
        this.showErrorDialog(this.$store.getters.invalidInputError);
        // this.sendConfirmationEmail()
        window.scroll(0, 0); // Scroll the window up so they have to scroll down the application to see what's missing
      } else {
        this.registerUser();
      }
    },
    registerUser() {
      this.$store
        .dispatch("registerUser", {
          email: this.familyFormData.email,
          password: this.familyFormData.email,
          user_type: "employer",
          status: "Applied",
          phone: this.familyFormData.phone,
        })
        .then(() => {
          // Send myself an email notification that a new client started a quote
          this.$store.dispatch("sendEmails", {
            subject: "New Family Form Submission",
            message:
              "New Family Form submitted by: " +
              this.familyFormData.first_name +
              " " +
              this.familyFormData.last_name +
              " | " +
              this.familyFormData.email +
              "\nPlease log into the administrator dashboard to view it!",
            from: this.$store.getters.agencyFromEmail,
            emails: [
              this.$store.getters.enginehireLoggingEmail,
              this.$store.getters.agencyAdminEmail,
            ],
            reply: this.$store.getters.agencyReplyEmail,
            userID: 4,
          });
          this.patchDetails();
        })
        .catch((error) => {
          console.log(error);
          this.showErrorDialog(this.$store.getters.submitError);
        });
    },
    async patchDetails() {
      // Need to store all the contact info after creating the user
      const res = await axios.patch(
        "/api/people/" + this.$store.getters.userID.toString() + "/",
        this.familyFormData
      );
      if (res == null) {
        return;
      }
      if (this.listChildren.length === 0) {
        this.showResultDialog(this.$store.getters.submitSuccessFamilyForm);
        return;
      }
      for (const child of this.listChildren) {
        const resChild = await axios.post("/api/children/", {
          user: this.$store.getters.userID,
          type: "Child",
          ...child,
          agency: this.$store.getters.agencyID,
          agency_owner: this.$store.getters.agencyName,
        });
        if (resChild == null) {
          return;
        }
        this.numberChildrenSubmitSuccess += 1;
        this.handleSubmittedChildren();
      }
    },
    handleSubmittedChildren() {
      if (this.numberChildrenSubmitSuccess === this.listChildren.length) {
        this.showResultDialog(this.$store.getters.submitSuccessFamilyForm);
        this.sendConfirmationEmail()
      }
    },
    dashboardRedirect() {
      let userID = this.$store.getters.userID;
      axios
        .get("/api/people/?id=".concat(userID))
        .then((res) => {
          console.log(res.data);
          this.user = res.data[0];

          if (this.user.is_candidate) {
            router.replace({ name: "Candidate Dashboard" });
          } else if (this.user.is_employer) {
            router.replace({ name: "Employer Dashboard" });
          } else if (this.user.is_agent) {
            router.replace({ name: "Agent Dashboard" });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    sendConfirmationEmail() {
      axios.get(`/api/emailtemplates/?agency=${this.$store.getters.agencyID}&type=Registration&selector1=Employer&deactivated=false`) // Get the email template corresponding to employer registration
        .then(res => {
          console.log(res)
          if (res.data.length) { // If there is an email template for this new status
            let emailTemplate = res.data[0]

            let agencyEmail = this.$store.getters.agencyFromEmail

            console.log(emailTemplate)
            this.$store.dispatch('sendEmails', {
              subject: emailTemplate.subject,
              message: emailTemplate.body.replace('[[fname]]', this.familyFormData.first_name), // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace
              // from: this.$store.getters.agencyFromEmail,
              from: agencyEmail,
              emails: [this.$store.getters.enginehireLoggingEmail, this.familyFormData.email],
              // reply: this.$store.getters.agencyReplyEmail,
              reply: agencyEmail,
              userID: this.$store.getters.userID ? this.$store.getters.userID : 4,
              html: true,
            })
          }
        })
        .catch(error => console.log(error))
    },
  },
};
</script>

<style>
.required-field {
  color: red !important;
  font-weight: 600 !important;
}
.required-message {
  color: red;
  font-family: "Open Sans", "Crimson Text";
  font-weight: 600;
  margin-top: 2px;
}

.form-note {
  font-weight: 500;
  color: var(--coredarkcolor);
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}

.fee-note {
  margin-bottom: -0.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/employers/applications/FamilyForm.vue